import IssueModal from './IssueModal';

export default IssueModal;
